import { useEffect } from 'react';
import { useLocalParticipant, useRoomContext } from '@livekit/components-react';
import { Track } from 'livekit-client';
import { useFaceFilter } from '../filters/useFaceFilter';
import { useFilterState } from '../filters/useFilterState';

const ManualPublisher = ({ socket, isHost = false }) => {
  const room = useRoomContext();
  const { localParticipant } = useLocalParticipant();
  const identity = room?.localParticipant?.identity;
  const activeFilterId = useFilterState({ socket, identity, isHost });
  const { filteredVideoTrack, audioTrack, error } = useFaceFilter({ activeFilterId });

  useEffect(() => {
    if (!localParticipant || !filteredVideoTrack) return undefined;
    let published = null;
    let cancelled = false;
    (async () => {
      try {
        published = await localParticipant.publishTrack(filteredVideoTrack, {
          source: Track.Source.Camera,
          name: 'filtered-cam',
        });
      } catch (e) {
        if (!cancelled) console.error('publish filtered video failed:', e);
      }
    })();
    return () => {
      cancelled = true;
      if (published) {
        try {
          localParticipant.unpublishTrack(published.track, true);
        } catch (_) {}
      }
    };
  }, [localParticipant, filteredVideoTrack]);

  useEffect(() => {
    if (!localParticipant || !audioTrack) return undefined;
    let published = null;
    let cancelled = false;
    (async () => {
      try {
        published = await localParticipant.publishTrack(audioTrack, {
          source: Track.Source.Microphone,
          name: 'mic',
        });
      } catch (e) {
        if (!cancelled) console.error('publish audio failed:', e);
      }
    })();
    return () => {
      cancelled = true;
      if (published) {
        try {
          localParticipant.unpublishTrack(published.track, true);
        } catch (_) {}
      }
    };
  }, [localParticipant, audioTrack]);

  useEffect(() => {
    if (error) console.warn('ManualPublisher pipeline error:', error);
  }, [error]);

  return null;
};

export default ManualPublisher;
